import { useImpression } from '@thd-olt-component-react/impression';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import {
  getOrientationType,
  getImageAndTextWidthClasses,
  getTextPaddingClasses,
  getRenderObj,
  getLeftSpaceClasses
} from '../components/utils/helpers';

export const useNewspaper = ({
  componentId,
  componentClass,
  livePreviewData = null
}) => {
  const { data } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass
    }
  });

  const dataComponent = livePreviewData || data?.component;
  const description = dataComponent?.description || '';
  const richText = livePreviewData ? description?.json : description || '';

  const { lesser: mdLesserBreakpoint, exact: mdExactBreakpoint } = useBreakpoint('md');
  const lgLesserBreakpoint = useBreakpoint('lg').lesser;

  // Set up impression tracking
  const {
    ref,
    clickID
  } = useImpression({
    data: {
      id: componentId,
      name: 'NewspaperModule',
      component: 'NewspaperModule',
      position: 1,
      type: 'content'
    }
  });

  // If no data is available, return early
  if (!dataComponent) {
    return { hasData: false };
  }

  const damImageWidthBehavior = dataComponent?.damImageWidthBehavior;
  const descriptionAlignment = dataComponent?.descriptionAlignment;

  const { isCentered, isVertical, imageFirst } = getOrientationType(
    dataComponent?.damImageAlignmentBehavior,
    descriptionAlignment,
    richText
  );

  const { imageWidthClasses, textWidthClasses } = getImageAndTextWidthClasses(damImageWidthBehavior, isVertical);
  const textPaddingClasses = getTextPaddingClasses(descriptionAlignment);

  const { displayScenario, imageSrc } = getRenderObj({ mdLesserBreakpoint,
    mdExactBreakpoint,
    lgLesserBreakpoint,
    dataComponent });
  const leftSpaceClasses = getLeftSpaceClasses({ isVertical, isCentered, damImageWidthBehavior });

  return {
    hasData: true,
    ref,
    clickID,
    displayScenario,
    imageRenderObj: {
      link: dataComponent?.link,
      altText: dataComponent?.altText,
      imageWidthClasses,
      leftSpaceClasses,
      imageSrc,
      imageFirst,
    },
    richTextObj: {
      textWidthClasses,
      textPaddingClasses,
      richText,
      imageFirst
    }
  };
};